export var Ease = {
    linear,
    linearNone: linear,
    linearIn,
    linearInOut,
    linearOut,
    bounceIn,
    bounceInOut,
    bounceOut,
    backIn,
    backInOut,
    backOut,
    elasticIn,
    elasticInOut,
    elasticOut,
    strongIn,
    strongInOut,
    strongOut,
    sineInOut,
    sineIn,
    sineOut,
    quintIn,
    quintInOut,
    quintOut,
    quartIn,
    quartInOut,
    quartOut,
    cubicIn,
    cubicInOut,
    cubicOut,
    quadIn,
    quadInOut,
    quadOut,
    expoIn,
    expoInOut,
    expoOut,
    circIn,
    circInOut,
    circOut,
};
const HALF_PI = Math.PI * 0.5;
const PI2 = Math.PI * 2;
function linear(t, b, c, d) {
    return c * t / d + b;
}
function linearIn(t, b, c, d) {
    return c * t / d + b;
}
function linearInOut(t, b, c, d) {
    return c * t / d + b;
}
function linearOut(t, b, c, d) {
    return c * t / d + b;
}
function bounceIn(t, b, c, d) {
    return c - Ease.bounceOut(d - t, 0, c, d) + b;
}
function bounceInOut(t, b, c, d) {
    if (t < d * 0.5)
        return Ease.bounceIn(t * 2, 0, c, d) * .5 + b;
    else
        return Ease.bounceOut(t * 2 - d, 0, c, d) * .5 + c * .5 + b;
}
function bounceOut(t, b, c, d) {
    if ((t /= d) < (1 / 2.75))
        return c * (7.5625 * t * t) + b;
    else if (t < (2 / 2.75))
        return c * (7.5625 * (t -= (1.5 / 2.75)) * t + .75) + b;
    else if (t < (2.5 / 2.75))
        return c * (7.5625 * (t -= (2.25 / 2.75)) * t + .9375) + b;
    else
        return c * (7.5625 * (t -= (2.625 / 2.75)) * t + .984375) + b;
}
function backIn(t, b, c, d, s = 1.70158) {
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
}
function backInOut(t, b, c, d, s = 1.70158) {
    if ((t /= d * 0.5) < 1)
        return c * 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
}
function backOut(t, b, c, d, s = 1.70158) {
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
}
function elasticIn(t, b, c, d, a = 0, p = 0) {
    var s;
    if (t == 0)
        return b;
    if ((t /= d) == 1)
        return b + c;
    if (!p)
        p = d * .3;
    if (!a || (c > 0 && a < c) || (c < 0 && a < -c)) {
        a = c;
        s = p / 4;
    }
    else
        s = p / PI2 * Math.asin(c / a);
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * PI2 / p)) + b;
}
function elasticInOut(t, b, c, d, a = 0, p = 0) {
    var s;
    if (t == 0)
        return b;
    if ((t /= d * 0.5) == 2)
        return b + c;
    if (!p)
        p = d * (.3 * 1.5);
    if (!a || (c > 0 && a < c) || (c < 0 && a < -c)) {
        a = c;
        s = p / 4;
    }
    else
        s = p / PI2 * Math.asin(c / a);
    if (t < 1)
        return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * PI2 / p)) + b;
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * PI2 / p) * .5 + c + b;
}
function elasticOut(t, b, c, d, a = 0, p = 0) {
    var s;
    if (t == 0)
        return b;
    if ((t /= d) == 1)
        return b + c;
    if (!p)
        p = d * .3;
    if (!a || (c > 0 && a < c) || (c < 0 && a < -c)) {
        a = c;
        s = p / 4;
    }
    else
        s = p / PI2 * Math.asin(c / a);
    return (a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * PI2 / p) + c + b);
}
function strongIn(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
}
function strongInOut(t, b, c, d) {
    if ((t /= d * 0.5) < 1)
        return c * 0.5 * t * t * t * t * t + b;
    return c * 0.5 * ((t -= 2) * t * t * t * t + 2) + b;
}
function strongOut(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
}
function sineInOut(t, b, c, d) {
    return -c * 0.5 * (Math.cos(Math.PI * t / d) - 1) + b;
}
function sineIn(t, b, c, d) {
    return -c * Math.cos(t / d * HALF_PI) + c + b;
}
function sineOut(t, b, c, d) {
    return c * Math.sin(t / d * HALF_PI) + b;
}
function quintIn(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
}
function quintInOut(t, b, c, d) {
    if ((t /= d * 0.5) < 1)
        return c * 0.5 * t * t * t * t * t + b;
    return c * 0.5 * ((t -= 2) * t * t * t * t + 2) + b;
}
function quintOut(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
}
function quartIn(t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
}
function quartInOut(t, b, c, d) {
    if ((t /= d * 0.5) < 1)
        return c * 0.5 * t * t * t * t + b;
    return -c * 0.5 * ((t -= 2) * t * t * t - 2) + b;
}
function quartOut(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
}
function cubicIn(t, b, c, d) {
    return c * (t /= d) * t * t + b;
}
function cubicInOut(t, b, c, d) {
    if ((t /= d * 0.5) < 1)
        return c * 0.5 * t * t * t + b;
    return c * 0.5 * ((t -= 2) * t * t + 2) + b;
}
function cubicOut(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function quadIn(t, b, c, d) {
    return c * (t /= d) * t + b;
}
function quadInOut(t, b, c, d) {
    if ((t /= d * 0.5) < 1)
        return c * 0.5 * t * t + b;
    return -c * 0.5 * ((--t) * (t - 2) - 1) + b;
}
function quadOut(t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
}
function expoIn(t, b, c, d) {
    return (t == 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b - c * 0.001;
}
function expoInOut(t, b, c, d) {
    if (t == 0)
        return b;
    if (t == d)
        return b + c;
    if ((t /= d * 0.5) < 1)
        return c * 0.5 * Math.pow(2, 10 * (t - 1)) + b;
    return c * 0.5 * (-Math.pow(2, -10 * --t) + 2) + b;
}
function expoOut(t, b, c, d) {
    return (t == d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
}
function circIn(t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
}
function circInOut(t, b, c, d) {
    if ((t /= d * 0.5) < 1)
        return -c * 0.5 * (Math.sqrt(1 - t * t) - 1) + b;
    return c * 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
}
function circOut(t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
}
